import { appRoutes } from "routes";

export const COMMON_LINKS = [
  {
    name: "Home",
    to: appRoutes.rootPath(),
    exact: true,
  },
  {
    name: "Videos",
    to: appRoutes.videosPath(),
  },
  {
    name: "Artists",
    to: appRoutes.contentfulPagePath("artists-page"),
  },
];

export const NOT_AUTH_LINKS = [
  {
    name: "Sign Up",
    to: appRoutes.signUpPath(),
    activeLink: false,
    button: true,
  },
  {
    name: "Log In",
    to: appRoutes.loginPath(),
  },
];

export const AUTH_LINKS = [
  // JJR-171 New menu
  // {
  //   name: "Activity",
  //   to: appRoutes.activityPath(),
  // },
  {
    name: "People",
    to: appRoutes.peoplePath(),
  },
  {
    name: "Account",
    to: appRoutes.myAccountPath(),
  },
];
